(function() {
  Drupal.behaviors.bruksSiwertelHeader = {
    attach: function (context) {
      // The .header element
      const headerElement = document.querySelector('.header');
      const compressedHeaderElement = document.querySelector(
        '.header--compressed'
      );
      const menuSmallscreenElement = document.querySelector('.menu-smallscreen');

      // Function to be triggered when the header element is out of view
      function headerOutOfView(entries) {
        entries.forEach((entry) => {
          // Check if the body does not contain the header--do-not-expand class
          if (!document.body.classList.contains('header--do-not-expand')) {
            if (!entry.isIntersecting) {
              // Header is out of view
              compressedHeaderElement.style.opacity = 1;
              compressedHeaderElement.style.display = 'flex';
              compressedHeaderElement.classList.add('slide-in-from-top');
              menuSmallscreenElement.style.paddingTop = '74px';
            } else {
              // Header is in view
              compressedHeaderElement.style.opacity = 0;
              compressedHeaderElement.style.display = 'none';
              compressedHeaderElement.classList.remove('slide-in-from-top');
              menuSmallscreenElement.style.paddingTop = '146px';
            }
          } else {
            compressedHeaderElement.style.display = 'flex';
            compressedHeaderElement.style.opacity = 1;
            menuSmallscreenElement.style.paddingTop = '74px';
          }
        });
      }

      // Options for the Intersection Observer
      const options = {
        root: null, // Use the viewport as the root
        threshold: 0, // Intersection ratio required to trigger the callback
      };

      // Create the Intersection Observer instance
      const observer = new IntersectionObserver(headerOutOfView, options);

      observer.observe(headerElement);
    },
  };
}());